'use client';

import { ErrorPage } from 'client/modules/error/500/ErrorPage';

export default ErrorPage;
